import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-744b3100")

_pushScopeId("data-v-744b3100")
const _hoisted_1 = { class: "page categories-post-list-page" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = { class: "text-muted" }
const _hoisted_4 = {
  key: 0,
  class: "no-posts"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("h2", null, "No Posts Yet", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("p", null, "There's nothing in this category yet.", -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("a", {
  href: "/categories",
  title: "Other Categories",
  class: "btn other-categories"
}, " See Other Categories ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_post = _resolveComponent("post")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createBlock("article", _hoisted_1, [
    _createVNode("h1", null, [
      _createTextVNode(_toDisplayString(_ctx.pageData.category.title) + " Posts", 1),
      _hoisted_2,
      _createVNode("small", _hoisted_3, "(Page " + _toDisplayString(_ctx.pageData.pagination.currentPage) + " of " + _toDisplayString(_ctx.pageData.pagination.totalPages) + ")", 1)
    ]),
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.pageData.posts, (post) => {
      return (_openBlock(), _createBlock(_component_post, {
        key: post.id,
        post: post
      }, null, 8, ["post"]))
    }), 128)),
    _createVNode(_component_pagination),
    (_ctx.pageData.posts.length === 0)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _hoisted_6
        ]))
      : _createCommentVNode("", true),
    _hoisted_7
  ]))
})